import { A } from '@solidjs/router';
import { type JSX, Match, Switch } from 'solid-js';
import { t } from '../i18n';
import { type OnboardingStatus, useOnboardingState } from '../lib/onboarding';
import { SESSION_TOKEN } from '../lib/session';

// The topbar's MCP chip (the canvas topbar, 08 / APP). Container — one read, the
// onboarding state the sidebar's `FinishSetupCta` already loads, so the chip adds
// no request.
//
// WHAT IT CAN HONESTLY SAY. The funnel's `mcp_connected` rung is settled by the
// account holding at least one live human-bound API token
// (`OnboardingEvent.McpConnected`) — evidence a chat client was SET UP, not that
// one is connected now. And the funnel never moves backwards, so a token revoked
// later still reads as set up. Hence "MCP set up" (owner ruling D3), never
// "connected".
//
// What each state renders:
//   - `mcp_connected` / `active`  → the settled chip, shipped green;
//   - `invalid`                   → NOTHING: that state is reachable from
//                                   `yml_requested` too, so it proves neither way;
//   - any earlier state           → an outline chip linking to the setup step;
//   - not loaded / refused        → nothing.

type McpVerdict = 'set_up' | 'not_set_up' | 'unknown';

export function mcpVerdict(status: OnboardingStatus | undefined): McpVerdict {
  if (status === undefined) return 'unknown';
  switch (status.state) {
    case 'mcp_connected':
    case 'active':
      return 'set_up';
    case 'invalid':
      return 'unknown';
    default:
      return 'not_set_up';
  }
}

export function McpChip(props: {
  readonly resolve: (href: string) => string;
  /** Test seam: the bearer the read uses. The app passes nothing. */
  readonly token?: string | null;
}): JSX.Element {
  const onboarding = useOnboardingState(props.token === undefined ? SESSION_TOKEN : props.token);
  const verdict = (): McpVerdict => (onboarding.isError ? 'unknown' : mcpVerdict(onboarding.data));
  return (
    <Switch>
      <Match when={verdict() === 'set_up'}>
        <span class="mcp-chip mcp-chip--set">{t('mcp_chip.set_up')}</span>
      </Match>
      <Match when={verdict() === 'not_set_up'}>
        <A class="mcp-chip mcp-chip--todo" href={props.resolve('/onboarding')}>
          {t('mcp_chip.connect')}
        </A>
      </Match>
    </Switch>
  );
}
